import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome5-families',
	templateUrl:'./FontAwesome5FamiliesPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesome5FamiliesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesome5FamiliesPluginCompPage
{
	mdContent_915 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5pro.FontAwesome5Families;
\`\`\``;
	mdContent_916 = `\`\`\`java
// Set the family on the page configurator
FontAwesome5ProPageConfigurator.enableFamily(IconFamily.Jelly);

// Use the icon with the family
var icon = new FontAwesome<>()
    .setIcon(FontAwesome5ProIcons.star)
    .setFamily(FontAwesome5Families.Jelly);
\`\`\``;
}
